import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";
import ImageUploader from "@/components/ImageUploader";

export default function AdminGallery() {
  const [events, setEvents] = useState([]);
  const [selected, setSelected] = useState(null);
  const [newImage, setNewImage] = useState("");

  const load = async () => {
    const all = await api.get("/events?past=true");
    setEvents(all.data);
    if (!selected && all.data.length) setSelected(all.data[0].id);
  };
  useEffect(() => { load(); }, []);

  const current = events.find((e) => e.id === selected);

  const add = async () => {
    if (!newImage.trim()) { toast.error("Add an image first"); return; }
    await api.post(`/admin/events/${selected}/gallery`, { url: newImage });
    setNewImage("");
    toast.success("Added");
    load();
  };
  const remove = async (url) => {
    await api.delete(`/admin/events/${selected}/gallery?url=${encodeURIComponent(url)}`);
    toast.success("Removed"); load();
  };

  return (
    <div data-testid="admin-gallery">
      <div className="mb-8">
        <h1 className="font-serif text-3xl text-brand-soft">Past event gallery</h1>
        <p className="text-sm text-brand-soft/60 mt-1">Upload memory photos for events you&apos;ve marked as past.</p>
      </div>

      {events.length === 0 ? (
        <div className="text-brand-soft/60 italic">Mark an event as &quot;past&quot; first (in Events) to upload its gallery.</div>
      ) : (
        <>
          <div className="flex flex-wrap gap-2 mb-6">
            {events.map((e) => (
              <button key={e.id} onClick={() => setSelected(e.id)} className={`px-4 py-2 rounded-full text-sm ${selected === e.id ? "bg-brand-maroon text-brand-cream" : "bg-white border border-brand-maroon/10 hover:border-brand-maroon/30"}`}>
                {e.title}
              </button>
            ))}
          </div>

          {current && (
            <>
              <div className="bg-white rounded-2xl border border-brand-maroon/10 p-6 mb-6 space-y-4">
                <ImageUploader label="Add a photo" recommended="(recommended 1200×900)" value={newImage} onChange={setNewImage} />
                <button onClick={add} className="btn-primary-furshala inline-flex items-center gap-2"><Plus className="w-4 h-4" /> Add to gallery</button>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                {(current.gallery || []).map((g, i) => (
                  <div key={i} className="relative group rounded-xl overflow-hidden bg-brand-ivory aspect-square">
                    <img src={fileUrl(g)} alt="" className="w-full h-full object-cover" />
                    <button onClick={() => remove(g)} className="absolute top-2 right-2 p-1.5 rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity text-red-700 hover:bg-red-50">
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                ))}
              </div>
              {(current.gallery || []).length === 0 && <div className="text-brand-soft/60 italic mt-4">No photos yet — add the first one.</div>}
            </>
          )}
        </>
      )}
    </div>
  );
}
